/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {creativeSetListCommons} from './creative-set-commons';
import {PERMISSIONS} from '../../components/auth/auth-constants';
import {CreativeSetResource} from '../../components/api/resources/resource/creative-set.resource';
import {AdnTimeShifterService} from '../../components/util/adn-time-shifter.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-creative-set-route-page',
  template: `
    <adn-creative-set-list-page
      *ngIf="list"
      [list]="list">
    </adn-creative-set-list-page>
  `
})
export class CreativeSetRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(CreativeSetResource) private readonly CreativeSet: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any,
    @Inject(AdnTimeShifterService) private readonly adnTimeShifter: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasAny(PERMISSIONS.manageAdvertising.apiKey)
      && !this.LocalUserPermissions.hasAny(PERMISSIONS.axAdvertiser.apiKey)
      && !this.LocalUserPermissions.hasAny(PERMISSIONS.creativeAgency.apiKey);

    creativeSetListCommons(this.list, false, this.LocalNetworkProfile, this.adnTimeShifter);

    this.adnListHelper.setUpList(this.list, this.CreativeSet, readOnly, 'fullCreativeSetList', {
      baseTable: 'creativeSet',
      afterFill: () => {
        creativeSetListCommons(this.list, true, this.LocalNetworkProfile, this.adnTimeShifter);
      }
    });
  }
}
